var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Our Story")]),_c('section',{staticClass:"lefttext"},[_c('vue-markdown',{staticClass:"md",attrs:{"source":_vm.markdown}}),_c('img',{attrs:{"src":require("../assets/successkid.jpeg")}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }